declare global {
    interface Document {
        env: Record<string, boolean | string | number>;
    }
}

export class Environment {
    basePath: string;


    constructor(
        public production: boolean,
        public apiUrl: string,

        public authDomain: string,
        public authClientId: string,
        public authAudience: string
    ) {
        this.basePath = document.baseURI;
    }

    public get endpoints() {
        return {
            data: this.apiUrl + '/data',
            audit: this.apiUrl + '/audit',
            admin: this.apiUrl + '/admin',
            tenants: this.apiUrl + '/tenants',
            accounts: this.apiUrl + '/accounts',
            metadata: this.apiUrl + '/metadata',
            systemMetadata: this.apiUrl + '/systemMetadata',
            reports: this.apiUrl + '/reports',
            actuator: this.apiUrl + '/actuator'
        };
    }
}
